import type { ChangePasswordFormSchema } from '@/modules/profile/components/ChangePasswordForm/ChangePasswordForm.types'

export const changePasswordFormDefaultValues: ChangePasswordFormSchema = {
  confirmPassword: '',
  currentPassword: '',
  newPassword: '',
}
